// tslint:disable
export enum EnrollmentScenario {
    /**
     * @description Nothing/error rout
     */
    Undetermined = 0,
    /**
     * @description create a new initial enrollment or an enrollment after a time gap
     */
    NewEnrollment = 1,
    /**
     * @description update an existing enrollment
     */
    Update = 2,
    /**
     * @description end an existing enrollment early and create a new one for the remaining time 
     */
    KeyUpdate = 3,
    /**
     * @description create a new enrollment in the future, despite the patient having a current enrollment
     */
    ReEnrollment = 4,
    /**
     * @description End all existing enrollments without creating anything new.
     */
    DisEnrollment = 5,
}
(EnrollmentScenario as any)['UNDETERMINED'] = 0;
(EnrollmentScenario as any)['NEWENROLLMENT'] = 1;
(EnrollmentScenario as any)['UPDATE'] = 2;
(EnrollmentScenario as any)['KEYUPDATE'] = 3;
(EnrollmentScenario as any)['REENROLLMENT'] = 4;
(EnrollmentScenario as any)['DISENROLLMENT'] = 5;
